import {
  createStyles,
  Paper,
  Theme,
  Typography,
  WithStyles,
  withStyles,
  TextField,
  FormControl,
  OutlinedInput,
  InputAdornment,
  IconButton,
  Avatar,
  CardActionArea,
  Divider,
  FormControlLabel,
  Switch,
  Link,
} from "@material-ui/core";
import * as React from "react";
import logoIcon from "../assets/images/logo_3.png";
import ButtonComponent from "../components/ButtonComponent";
import { Formik, Form } from "formik";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import EmailIcon from "@material-ui/icons/Email";
import WorkIcon from "@material-ui/icons/Work";
import * as Yup from "yup";
import { AuthConsumer } from "../routes/AuthContext";
const CustomSwitch = withStyles({
  colorSecondary: {
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "orange",
    },
  },
  track: {
    backgroundColor: "grey",
  },
})(Switch);
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    fab: {
      margin: 0, // You might not need this now
      position: "fixed",
      bottom: 0,
      right: 0,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
  });
interface Props extends WithStyles<typeof styles> {
  onLoginSuccess: any;
  onForgotPassword: any;
}

const loginValidationEmailSchema = Yup.object().shape({
  email: Yup.string().email("Email is invalid").required("Email is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});
const loginValidationNumberSchema = Yup.object().shape({
  employeeNumber: Yup.string().required("Employee number is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

const loginValidationDashboardSchema = Yup.object().shape({
  employeeNumber: Yup.string().required("Dashboard username is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("Password is required"),
});

class LoginScreen extends React.Component<Props> {
  state = {
    errorMessage: "",
    showPassword: false,
    loginType: "EMAIL",
    dashboardUser: false,
  };
  handleClose = () => {
    this.setState({
      showError: false,
    });
  };
  onToggleRegister = () => {
    this.setState({ register: true });
  };
  onShowPassword = () => {
    this.setState({
      showPassword: !this.state.showPassword,
    });
  };
  handleMouseDownPassword = (event: any) => {
    event.preventDefault();
  };
  loginWithEmployeeNumber = () => {
    this.setState({ loginType: "EMPLOYEE_NUMBER" });
  };
  loginWithEmail = () => {
    this.setState({ loginType: "EMAIL" });
  };
  render() {
    const { classes, onForgotPassword } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ initiateLogin }) => (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                alignItems: "center",
              }}
            >
              <Paper
                style={{
                  height: "100vh",
                  display: "flex",
                  width: "100%",
                  padding: 20,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Paper
                  style={{
                    width: "40%",
                    height: "100%",
                    borderTopLeftRadius: 10,
                    borderBottomLeftRadius: 10,
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      flex: 1,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "30%",
                        margin: "10%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <img
                        src={logoIcon}
                        width={"100%"}
                        height={"50%"}
                        color={"red"}
                        alt="SEGPI"
                      />
                      <Typography
                        variant={"h2"}
                        display={"block"}
                        style={{
                          fontSize: 24,
                          padding: 10,
                          textAlign: "center",
                        }}
                      >
                        Paperless Application
                      </Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        flex: 0.2,
                        justifyContent: "flex-end",
                      }}
                    ></div>
                  </div>
                </Paper>
                <Paper
                  style={{
                    width: "60%",
                    height: "100%",
                    overflow: "hidden",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    backgroundColor: "white",
                  }}
                >
                  <Typography
                    variant={"h2"}
                    style={{
                      fontSize: 32,
                      padding: 10,
                    }}
                  >
                    Login to the Dashboard
                  </Typography>
                  <Divider
                    style={{
                      height: 2,
                      width: "80%",
                    }}
                  />
                  <div
                    style={{
                      display: "flex",
                      marginTop: 10,
                      flexDirection: "row",
                    }}
                  >
                    <Paper elevation={this.state.loginType === "EMAIL" ? 3 : 0}>
                      <CardActionArea
                        onClick={() => this.loginWithEmail()}
                        style={{
                          padding: 20,
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            padding: 10,
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Avatar alt="Email" className={classes.large}>
                            <EmailIcon fontSize="large" />
                          </Avatar>
                          <Typography
                            variant={"h2"}
                            style={{
                              fontSize: 12,
                              marginTop: 20,
                              fontWeight: "bold",
                            }}
                          >
                            Email
                          </Typography>
                        </div>
                      </CardActionArea>
                      {this.state.loginType === "EMAIL" && (
                        <div
                          style={{
                            height: 3,
                            width: "100%",
                          }}
                        />
                      )}
                    </Paper>
                    <Paper
                      elevation={
                        this.state.loginType === "EMPLOYEE_NUMBER" ? 3 : 0
                      }
                      style={{ marginLeft: 20 }}
                    >
                      <CardActionArea
                        onClick={() => this.loginWithEmployeeNumber()}
                        style={{
                          padding: 20,
                          display: "flex",
                          justifyContent: "center",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            padding: 10,
                            display: "flex",
                            justifyContent: "center",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <Avatar alt="Email" className={classes.large}>
                            <WorkIcon fontSize="large" />
                          </Avatar>
                          {!this.state.dashboardUser ? (
                            <Typography
                              variant={"h2"}
                              style={{
                                fontSize: 12,
                                marginTop: 20,
                                fontWeight: "bold",
                              }}
                            >
                              Employee number
                            </Typography>
                          ) : (
                              <Typography
                                variant={"h2"}
                                style={{
                                  fontSize: 12,
                                  marginTop: 20,
                                  fontWeight: "bold",
                                }}
                              >
                                Dashbaord username
                              </Typography>
                            )}
                        </div>
                      </CardActionArea>
                      {this.state.loginType === "EMPLOYEE_NUMBER" && (
                        <div
                          style={{
                            height: 3,
                            width: "100%",
                          }}
                        />
                      )}
                    </Paper>
                  </div>
                  <FormControlLabel
                    style={{ marginTop: 20 }}
                    control={
                      <CustomSwitch
                        checked={this.state.dashboardUser}
                        style={{
                          color: this.state.dashboardUser ? "#f96500" : "white",
                        }}
                        onChange={(event: any) =>
                          this.setState({
                            loginType: "EMPLOYEE_NUMBER",
                            dashboardUser: event.target.checked,
                          })
                        }
                        name="checkedA"
                      />
                    }
                    label="Dashboard User"
                  />
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: 20,
                    }}
                  >
                    <Formik
                      initialValues={{
                        email: "",
                        employeeNumber: "",
                        password: "",
                      }}
                      validationSchema={
                        this.state.loginType === "EMAIL"
                          ? loginValidationEmailSchema
                          : this.state.dashboardUser
                            ? loginValidationDashboardSchema
                            : loginValidationNumberSchema
                      }
                      onSubmit={(values, { resetForm }) => {
                        initiateLogin(
                          values,
                          this.state.loginType,
                          this.state.dashboardUser
                        );
                        resetForm();
                      }}
                    >
                      {({
                        values,
                        handleChange,
                        handleBlur,
                        errors,
                        isValid,
                        touched,
                      }) => (
                          <Form
                            style={{
                              width: "100%",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "column",
                              display: "flex",
                            }}
                          >
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                              }}
                            >
                              {this.state.loginType === "EMAIL" && (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}
                                >
                                  <TextField
                                    style={{
                                      width: "80%",
                                      marginTop: 10,
                                      marginBottom: 10,
                                      marginLeft: 10,
                                    }}
                                    id={"email"}
                                    value={values.email}
                                    onChange={handleChange}
                                    type={"email"}
                                    onBlur={handleBlur}
                                    variant="outlined"
                                    name={"email"}
                                    label={"Email"}
                                    fullWidth
                                    error={errors.email ? true : false}
                                    helperText={errors.email}
                                  />
                                </div>
                              )}
                              {this.state.loginType === "EMPLOYEE_NUMBER" && (
                                <div
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}
                                >
                                  <TextField
                                    style={{
                                      width: "80%",
                                      marginTop: 10,
                                      marginBottom: 10,
                                      marginLeft: 10,
                                    }}
                                    id={"employeeNumber"}
                                    value={values.employeeNumber}
                                    onChange={handleChange}
                                    type={"text"}
                                    onBlur={handleBlur}
                                    variant="outlined"
                                    name={"employeeNumber"}
                                    label={
                                      this.state.dashboardUser
                                        ? "Dashboard username"
                                        : "Employee number"
                                    }
                                    fullWidth
                                    error={errors.employeeNumber ? true : false}
                                    helperText={errors.employeeNumber}
                                  />
                                </div>
                              )}

                              <div
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "column",
                                }}
                              >
                                <FormControl
                                  style={{
                                    width: "80%",
                                    marginTop: 10,
                                    marginBottom: 10,
                                    marginLeft: 10,
                                  }}
                                  variant="outlined"
                                >
                                  <OutlinedInput
                                    id="password"
                                    type={
                                      !this.state.showPassword
                                        ? "password"
                                        : "text"
                                    }
                                    onChange={handleChange}
                                    placeholder={"Password"}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          onClick={() => this.onShowPassword()}
                                          onMouseDown={(event: any) =>
                                            this.handleMouseDownPassword(event)
                                          }
                                        >
                                          {!this.state.showPassword ? (
                                            <Visibility />
                                          ) : (
                                              <VisibilityOff />
                                            )}
                                        </IconButton>
                                      </InputAdornment>
                                    }
                                    labelWidth={0}
                                  />
                                </FormControl>
                                <Typography
                                  variant={"subtitle1"}
                                  align={"right"}
                                  style={{
                                    color: "red",
                                    alignSelf: "right",
                                    width: "90%",
                                    marginLeft: 10,
                                  }}
                                >
                                  {errors.password}
                                </Typography>
                              </div>
                            </div>
                            <div
                              style={{
                                justifyContent: "right",
                                alignItems: "right",
                                width: "90%",
                              }}
                            ></div>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                justifyContent: "space-between",
                                alignItems: "center",
                              }}
                            >
                              {this.state.loginType === "EMAIL" && (
                                <ButtonComponent
                                  type="submit"
                                  disabled={
                                    !touched.email && !touched.password
                                      ? true
                                      : !isValid
                                  }
                                  text={"LOGIN"}
                                  onClick={() => { }}
                                />
                              )}
                              {this.state.loginType === "EMPLOYEE_NUMBER" && (
                                <ButtonComponent
                                  type="submit"
                                  disabled={
                                    !touched.employeeNumber && !touched.password
                                      ? true
                                      : !isValid
                                  }
                                  text={"LOGIN"}
                                  onClick={() => { }}
                                />
                              )}
                              <Link
                                style={{
                                  alignSelf: "flex-end",
                                  marginRight: "10%",
                                }}
                                onFocus={() => { }}
                                component="button"
                                variant="body2"
                                onClick={() => onForgotPassword()}
                              >
                                Forgot password
                            </Link>
                            </div>
                          </Form>
                        )}
                    </Formik>
                  </div>
                </Paper>
              </Paper>
            </div>
          )}
        </AuthConsumer>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(LoginScreen);
